var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThermal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 261,
    viewBox: "0 0 258 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_79)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: -3,
    width: 184.555,
    height: 184.555,
    rx: 14,
    transform: "rotate(45 129 -3)",
    fill: "#008E81"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: -2.29289,
    width: 183.555,
    height: 183.555,
    rx: 13.5,
    transform: "rotate(45 129 -2.29289)",
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.222 64.2392C135.622 62.6385 133.058 62.5886 131.397 64.0892C131.359 64.1171 131.272 64.1779 131.129 64.264C130.753 64.489 129.98 64.8931 128.662 65.3325C126.017 66.2141 121.199 67.2308 113.077 67.2308C102.048 67.2308 95.6376 69.4181 91.9244 72.3886C90.0386 73.8972 88.9478 75.5349 88.3483 76.9737C88.0541 77.6797 87.8899 78.3094 87.7995 78.8158C87.7543 79.0687 87.7276 79.2908 87.7121 79.4767C87.7043 79.5697 87.6994 79.6538 87.6964 79.7283L87.6932 79.833L87.6925 79.8799L87.6924 79.902L87.6923 79.9126C87.6923 79.9268 94.7551 79.9231 87.6923 79.9231C87.6923 82.2597 89.5865 84.1538 91.9231 84.1538C94.1396 84.1538 95.9581 82.4493 96.139 80.2795L96.1589 80.2282C96.2205 80.0805 96.4518 79.6028 97.2102 78.996C98.7855 77.7358 102.952 75.6923 113.077 75.6923C121.878 75.6923 127.637 74.5936 131.338 73.3598C133.193 72.7415 134.535 72.0879 135.482 71.5197C135.955 71.2358 136.327 70.9746 136.613 70.7521C136.756 70.641 136.877 70.5398 136.978 70.4507C137.029 70.4061 137.074 70.3646 137.115 70.3265L137.172 70.2718L137.198 70.2464L137.21 70.2342L137.216 70.2283C137.216 70.2283 132.356 65.3565 137.222 70.2224C138.875 68.5702 138.875 65.8914 137.222 64.2392Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.4615 88.4184C81.3934 88.4184 79.6283 89.9136 79.2883 91.9536L75.0576 117.338C75.0193 117.568 75 117.801 75 118.034V160.341C75 167.351 80.6825 173.034 87.6923 173.034H170.897C174.354 173.034 177.857 172.184 180.588 170.004C183.449 167.721 185 164.339 185 160.341V101.082C185 99.619 184.244 98.2595 183 97.4878C181.757 96.7161 180.203 96.6417 178.892 97.2912L155.385 108.933V101.082C155.385 99.5701 154.577 98.1727 153.267 97.4173C151.957 96.6619 150.343 96.6632 149.034 97.4209L130 108.44V101.111C130 99.5989 129.193 98.202 127.884 97.4464C126.575 96.6907 124.962 96.6911 123.653 97.4474L103.466 109.111L100.316 91.8878C99.9479 89.8782 98.1968 88.4184 96.1538 88.4184H83.4615ZM153.031 119.54L176.538 107.899V160.341C176.538 162.012 175.974 162.861 175.31 163.391C174.515 164.025 173.081 164.572 170.897 164.572H87.6923C85.3557 164.572 83.4615 162.678 83.4615 160.341V118.384L87.0455 96.8799H92.6268L96.2229 116.539C96.4705 117.892 97.3606 119.04 98.6095 119.618C99.8584 120.195 101.31 120.129 102.501 119.441L121.538 108.441V115.777C121.538 117.29 122.346 118.687 123.656 119.443C124.966 120.198 126.58 120.197 127.889 119.439L146.923 108.42V115.749C146.923 117.213 147.679 118.572 148.923 119.344C150.166 120.116 151.72 120.19 153.031 119.54Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_79",
    x: 0.299,
    y: 2.799,
    width: 257.402,
    height: 257.402,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_79"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_79",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermal);
export default __webpack_public_path__ + "static/media/thermal.076c31bed7296f07974acb5745e80f04.svg";
export { ForwardRef as ReactComponent };